import { render, staticRenderFns } from "./ReSort.vue?vue&type=template&id=4529b418&"
import script from "./ReSort.vue?vue&type=script&lang=js&"
export * from "./ReSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports